import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import './PrintPass.css';

const base_url = process.env.REACT_APP_BASE_URL;

const PrintSpecialPass = () => {
  const { id } = useParams();
  const [passData, setPassData] = useState(null);
  const [logo, setLogo] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    
    const fetchData = async () => {
      try {
        // Fetch visitor data
        const res = await axios.get(`${base_url}/visitor/get-special-visitor/${id}`);
        const visitorData = res.data.data;
        setPassData(visitorData);
        console.log("Special Pass Data", visitorData);

        // Check if pass is expired
        if (visitorData.visitingDate) {
          const endDate = new Date(visitorData.visitingDate);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
         /* if (endDate < today) {
            navigate('/expired-pass');
            return;
          } */
        }

        // Fetch company data if available
        if (visitorData.companyId) {
          const companyRes = await axios.get(`${base_url}/visitor/company/details/${visitorData.companyId}`);
          setCompanyData(companyRes.data.data);
          setLogo(companyRes.data.data.logo);
        }
      } catch (error) {
        console.error('Error fetching pass data:', error);
        navigate('/expired-pass');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="print-loading">
        <div className="spinner"></div>
        <p>Preparing pass for printing...</p>
      </div>
    );
  }

  if (!passData) {
    return <div className="print-error">Error loading pass data</div>;
  }

  // Format name to handle cases where firstName and lastName might be separate
  const visitorName = passData.firstName || passData.name || 'N/A';
  const visitorLastName = passData.lastName || '';
  const fullName = visitorLastName ? `${visitorName} ${visitorLastName}` : visitorName;

  return (
     <div className="print-container">
         <div className="id-card">
   
           {/* Header with Left Image, Center DigiPass, and Right Company Logo */}
           <div 
             className="id-card-header"
             style={{
               background: passData.passType === "Vendor"
                 ? "linear-gradient(to top, #0f531d, #06521b)"
                 : "linear-gradient(to top, #edd52a, #c99a29)",
               borderRadius: "0",
               height: "50px"
             }}
           >
             <img
               src={require("../../../assets/img/visitor-images/images/logo.png")}
               alt="Logo"
               className="left-logo"
             />
             
             <span className="digipass-text">DigiPass</span>
             
             {
               logo ? (
                 <img
                   src={logo}
                   alt="Company Logo"
                   className="company-logo"
                 />
               ) : (
                <div className="no-logo">No Logo</div>
               )
             }
           </div>
   
           {/* Pass Type */}
           <div className="pass-type">
             {passData.passType === 'PreBooking' ? 'VISITOR' : passData.passType}
           </div>
   
           {/* Photo and QR Code Container */}
           <div
             className={companyData?.boombarierQrCheck ? "photo-qr-container" : "id-card-photo"}
           >
             {passData.selfie ? (
               <img
                 src={passData.selfie}
                 alt="Visitor"
                 className="visitor-photo"
               />
             ) : (
               <div className="visitor-photo-initial">
                 {passData.firstName ? passData.firstName.charAt(0).toUpperCase() : 'V'}
               </div>
             )}
             {companyData?.boombarierQrCheck && (
               <div className="qr-code-container">
                 <QRCodeSVG
                   value={`https://digipass.co.in/special-pass/${passData._id}`}
                   size={100}
                   level="H"
                   fgColor="#0a66c2"
                 // bgColor="#ffffff"
                 />
               </div>
             )}
           </div>
           {/* Visitor Name */}
           <div className="visitor-name">
             {passData.firstName + " " + passData.lastName || 'Visitor Name'}
           </div>
   
           {/* Main Details */}
           <div className="id-card-details">
             <div className="detail-row">
               <span className="label">Phone</span>
               <span className="value">{passData.phone || 'N/A'}</span>
             </div>
             <div className="detail-row">
               <span className="label">Valid For</span>
               <span className="value">{passData.validityEndDate ? passData.validityEndDate.substring(0, 10) : passData.createdAt.substring(0, 10)}
               </span>
             </div>
           {passData.personToVisit && <div className="detail-row">
               <span className="label">Person to Visit</span>
               <span className="value">{passData.personToVisit || 'N/A'}</span>
             </div>}
         {passData.empDepartment && <div className="detail-row">
               <span className="label">Department</span>
               <span className="value">{passData.empDepartment || 'N/A'}</span>
             </div>}
           </div>
   
           {/* Footer */}
           <div className="id-card-footer">
           Powered by Fedicoms Pvt Ltd.
           </div>
         </div>
       </div>
  );
};

export default PrintSpecialPass;
